import { TextWrapperSpan, StyledImage, Wrapper } from "../../../constants/common/StyledGlobalConstants";
import CPNotification from "../../../pages/Login/CPNotification";
import PopOutIcon from "../../../assets/icons/External_link.svg";
import { getPendoId } from "../../../util/cfstPendoUtils";

const ContractAndCancellationsFAQWarning = (parentComponent = "NA") => {
  return (
    <CPNotification
      isOpen={true}
      notificationType="warning"
      closeButton={false}
      height="auto"
      role={parentComponent === "ServiceDetails" ? "" : "alert"}
      ariaHiddenValue={parentComponent === "ServiceDetails" ? "true" : "false"}
    >
      <Wrapper>
        <TextWrapperSpan>
          You will continue to be billed for this device unless you update your contract. For more information, read the{" "}
        </TextWrapperSpan>
        <TextWrapperSpan
          aria-label="Contracts and cancellations FAQ Link"
          tabIndex={0}
          textDecorationLine="underline"
          onClick={() => window.open("https://reveal-help.verizonconnect.com/hc/articles/17190169888787")}
          style={{ cursor: "pointer" }}
          id={getPendoId("contract-and-cancellations-faq-link")}
        >
          Contracts and cancellations FAQ.
        </TextWrapperSpan>
        <a href="https://reveal-help.verizonconnect.com/hc/articles/17190169888787" target="_blank" tabIndex="-1" aria-hidden="true">
          <TextWrapperSpan verticalAlign="sub" marginLeft="2px" tabIndex="-1" aria-hidden="true">
            <StyledImage
              tabIndex="-1"
              width="1rem"
              height="1rem"
              src={PopOutIcon}
              alt="link"
              id={getPendoId("contract-and-cancellations-faq-icon")}
              aria-hidden="true"
            />
          </TextWrapperSpan>
        </a>
      </Wrapper>
    </CPNotification>
  );
};

export default ContractAndCancellationsFAQWarning;
